import { BASE_CONFIG, THEME_COLORS, buildMapData, autoWrapText, calculateNodeHeight } from '../indent_tree_g6/tree'

const _BASE_CONFIG = {
  ...BASE_CONFIG,
  nodeWidth: 300,
  rootNodeWidth: 300 * 0.6
}

export function createTree(G6, options = {}) {
  const { Util } = G6;
  const { resultData : sourceData, liabilityShowType } = options
  const categoryKey = liabilityShowType === 1 ? 'insuranceId' : 'categoryId' // 分类的关键字：categoryId-按责任 insuranceId-按险种
  const _autoWrapText = autoWrapText.bind(null, G6)
  const _calculateNodeHeight = calculateNodeHeight.bind(null, G6)
  G6.registerNode('indentedRoot', {
    draw(model, group) {
      const { fontSize, padding, rootNodeWidth } = _BASE_CONFIG
      const { rootColor, rootBgColor } = THEME_COLORS
      const { label, nodeHeight } = model
      const rootRectShape = group.addShape('rect', {
        attrs: {
          x: rootNodeWidth - 20,
          y: 0,
          width: rootNodeWidth,
          height: nodeHeight,
          radius: 2,
          lineWidth: 2
        },
        name: 'root-rect-shape'
      })
      
      group.addShape('rect', {
        attrs: {
          x: rootNodeWidth / 2 - 20,
          y: 0,
          width: rootNodeWidth,
          height: nodeHeight,
          fill: rootBgColor,
          radius: 2,
          lineWidth: 2
        },
        name: 'root-rect-shape'
      })
      if (label) {
        const textWrap = _autoWrapText(label, {
          maxWidth: rootNodeWidth - padding * 2
        })
        group.addShape('text', {
          attrs: {
            text: textWrap.text,
            fill: rootColor,
            fontSize,
            x: rootNodeWidth - 20,
            y: nodeHeight / 2,
            textAlign: 'center',
            textBaseline: 'middle',
          },
          name: 'root-text-shape'
        });
      }

      return rootRectShape;
    },
    update: undefined
  });

  G6.registerNode('indentedNode', {
    drawCategory (model, group) {
      const { fontSize, padding, borderRadius, nodeWidth } = _BASE_CONFIG
      const { rootColor, rootBgColor, categoryBgColor } = THEME_COLORS
      const { isFirstElementOfTheCategory, categoryName, categoryTitleHeight, categoryBorderHeight } = model

      if (!isFirstElementOfTheCategory) {
        return
      }
      group.addShape('rect', {
        attrs: {
          x: -20,
          y: categoryTitleHeight - 1,
          width: nodeWidth + 40,
          height: categoryBorderHeight,
          radius: borderRadius,
          fill: categoryBgColor,
          opacity: 0.5
        },
        name: 'category-bg-rect-shape'
      });
      group.addShape('rect', {
        attrs: {
          x: -20,
          y: categoryTitleHeight - 1,
          width: nodeWidth + 40,
          height: categoryBorderHeight,
          radius: borderRadius,
          lineWidth: 2,
          lineDash: [9, 3],
          stroke: rootBgColor,
        },
        name: 'category-border-rect-shape'
      });

      if (categoryName) {
        const textWrap = _autoWrapText(categoryName, {
          maxWidth: nodeWidth - padding * 2
        })
        const textShape = group.addShape('text', {
          attrs: {
            text: textWrap.text,
            fill: rootColor,
            fontSize,
            x: 10,
            y: categoryTitleHeight / 2 + 2,
            textAlign: 'left',
            textBaseline: 'middle',
          },
          name: 'category-text-shape'
        });
        const textBBox = textShape.getBBox();
        const textWidth = textBBox.width + padding * 2;
        const rectAttrs = {
          x: 0,
          y: 0,
          width: textWidth,
          height: categoryTitleHeight,
          radius: [borderRadius, borderRadius, 0, 0],
          fill: rootBgColor
        };
        group.addShape('rect', {
          attrs: rectAttrs,
          name: 'category-text-rect-shape'
        });
        textShape.toFront()
      }
    },
    drawHeadline (model, group) {
      const { fontSize, margin, padding, borderRadius, nodeWidth } = _BASE_CONFIG
      const { rootColor, rootBgColor } = THEME_COLORS
      const { nodeHeight, categoryTitleHeight, titleHeight, headline } = model;

      if (!headline) {
        return
      }
      const categoryMarginTop = categoryTitleHeight ? categoryTitleHeight + margin : 0
      const bgTopDistance = categoryMarginTop + titleHeight
      group.addShape('rect', {
        attrs: {
          x: -10,
          y: bgTopDistance - 1,
          width: nodeWidth + padding * 2,
          height: nodeHeight - bgTopDistance,
          radius: borderRadius,
          lineWidth: 2,
          lineDash: [9, 3],
          stroke: rootBgColor
        },
        name: 'headline-bg-rect-shape'
      });

      const textWrap = _autoWrapText(headline, {
        maxWidth: nodeWidth - padding * 2
      })
      const titleShape = group.addShape('text', {
        attrs: {
          text: textWrap.text,
          fill: rootColor,
          fontSize,
          x: 10,
          y: categoryMarginTop + titleHeight / 2 + 2,
          textAlign: 'left',
          textBaseline: 'middle',
        },
        name: 'headline-text-shape'
      });
      const titleBBox = titleShape.getBBox();
      const textWidth = titleBBox.width + padding * 2;
      const titleRectShape = group.addShape('rect', {
        attrs: {
          x: 0,
          y: categoryMarginTop,
          width: textWidth,
          height: titleHeight,
          radius: [borderRadius, borderRadius, 0, 0],
          fill: rootBgColor
        },
        name: 'headline-rect-shape'
      });
      titleShape.toFront()
      return titleRectShape
    },
    drawPerson (model, group) {
      const { fontSize12, lineHeight, padding, borderRadius, nodeWidth } = _BASE_CONFIG
      const { productColor, productBgColor1, productBgColor2 } = THEME_COLORS
      const { isPerson, nodeHeight, label, label2 } = model;
      if (!isPerson) {
        return
      }

      let domHTML1 = ''
      const labelList = [label, label2]
      labelList.forEach(l => {
        const textWrap = _autoWrapText(l, {
          maxWidth: nodeWidth + 20,
          fontSize: fontSize12
        })
        domHTML1 += `<div style="padding: ${padding}px; line-height: ${lineHeight}; background: ${productBgColor1}; border-bottom: 1px solid rgba(255, 255, 255, 0.5);">
          ${textWrap.html}
        </div>`
      })
      let domHTML2 = `<div style="padding: ${padding / 2}px ${padding / 2}px 0; line-height: ${lineHeight}; color: ${productColor}; background: ${productBgColor2};">`
      model.insurances.forEach(ins => {
        const textWrap = _autoWrapText(ins.label, {
          maxWidth: nodeWidth + 20,
          fontSize: fontSize12
        })
        domHTML2 += `
          <span style="display: inline-block; padding: ${padding / 2}px; margin-bottom: ${padding / 2}px; background: #fcf4f2; border-radius: ${borderRadius}px;">
            ${textWrap.html}
          </span>
        `
      })
      domHTML2 += '</div>'

      const domHTML = `<div style="font-size: ${fontSize12}px; line-height: ${lineHeight};">
        ${domHTML1}
        ${domHTML2}
      </div>`
      const domShape = group.addShape('dom', {
        attrs: {
          width: nodeWidth + 20,
          height: nodeHeight,
          html: domHTML
        },
        name: 'dom-shape'
      });
      return domShape
    },
    drawLiability (model, group) {
      const { fontSize, fontSize12, lineHeight, margin, padding, borderRadius, nodeWidth } = _BASE_CONFIG
      const { isPerson, depth, nodeHeight, categoryTitleHeight, titleHeight, description1, description2, mainColor } = model;
      if (isPerson) {
        return
      }
      if (depth !== 1) {
        return
      }

      let marginTop = 0
      if (categoryTitleHeight) {
        marginTop += (categoryTitleHeight + margin)
      }
      if (titleHeight) {
        marginTop += (titleHeight + margin)
      }


      let domHTML1 = ''
      const textWrap01 = _autoWrapText(description1, {
        maxWidth: nodeWidth - padding * 2
      })
      if (textWrap01.html) {
        domHTML1 += `<div style="margin-bottom: ${description2 ? margin / 2 : 0}px; padding: ${padding}px; color: white; background: ${mainColor}; border-radius: ${borderRadius}px;">
          ${textWrap01.html}
        </div>`
      }

      let domHTML2 = ''
      const textWrap02 = _autoWrapText(description2, {
        maxWidth: nodeWidth - padding * 2,
        fontSize: fontSize12
      })
      if (textWrap02.html) {
        domHTML2 += `<p style="margin: 0; padding: ${padding / 2}px ${padding}px; font-size: ${fontSize12}px; line-height: ${lineHeight}; background: white; border-radius: ${borderRadius}px;">
          ${textWrap02.html}
        </p>`
      }

      let domHTML = `
        <div style="line-height: ${lineHeight}; font-size: ${fontSize}px;">
          ${domHTML1}
          ${domHTML2}
        </div>
      `
      const domShape = group.addShape('dom', {
        attrs: {
          y: marginTop,
          width: nodeWidth,
          height: nodeHeight,
          html: domHTML
        },
        name: 'dom-shape'
      });

      // debug：给整个节点加边框
      // group.addShape('rect', {
      //   attrs: {
      //     x: 0,
      //     y: 0,
      //     width: nodeWidth,
      //     height: nodeHeight,
      //     lineWidth: 1,
      //     stroke: mainColor
      //   },
      //   name: 'node-border-rect-shape'
      // });
      return domShape
    },
    draw(model, group) {
      this.drawHeadline(model, group)
      this.drawCategory(model, group)
      const personDraw = this.drawPerson(model, group)
      const liabilityDraw = this.drawLiability(model, group)
      return personDraw || liabilityDraw
    }
  });

  G6.registerEdge('indentedEdge', {
    afterDraw: (cfg, group) => {
      const sourceNode = cfg.sourceNode.getModel();
      const targetNode = cfg.targetNode.getModel();
      const color = sourceNode.mainColor || targetNode.mainColor || cfg.color || '#000';
      const keyShape = group.get('children')[0];
      keyShape.attr({
        stroke: color,
        lineWidth: 3 // branchThick
      });
      group.toBack();
    },
    getControlPoints: (cfg) => {
      const { margin } = _BASE_CONFIG
      const { startPoint, endPoint } = cfg
      endPoint.y += (endPoint.description1 ? 13 : 6)
      if (endPoint.categoryTitleHeight) {
        endPoint.y += (endPoint.categoryTitleHeight + margin)
      }
      if (endPoint.titleHeight) {
        endPoint.y += (endPoint.titleHeight + margin)
      }
      return [
        startPoint,
        {
          x: startPoint.x,
          y: endPoint.y,
        },
        endPoint
      ];
    },
    update: undefined
  }, 'polyline');

  const dataTransform = (data) => {
    const { margin } = _BASE_CONFIG
    const changeData = (d, level = 0) => {
      const data = {
        ...d,
        type: d.depth === 0 ? 'indentedRoot' : 'indentedNode',
        nodeHeight: _calculateNodeHeight(d, _BASE_CONFIG)
      };

      if (d.children) {
        data.children = d.children.map((child) => changeData(child, level + 1));
      }
      if (data.children && data.children.length) {
        const halfLength = Math.floor(data.children.length / 2)
        const categoryIdsSet = new Set(data.children.filter((e, i) => !!e[categoryKey] && i < halfLength).map(e => e[categoryKey]))
        data.children.forEach((subtree, i) => {
          if (subtree.isPerson) {
            subtree.side = 'right'
          } else if (categoryIdsSet.has(subtree[categoryKey])) {
            subtree.side = 'right'
          }
          subtree.mainColor = THEME_COLORS.colors[i % THEME_COLORS.colors.length];
          Util.traverseTree(subtree, child => {
            child.mainColor = THEME_COLORS.colors[i % THEME_COLORS.colors.length];
            return true;
          })
        });
      }
      return data;
    };

    Util.traverseTree(data, child => {
      child.nodeHeight = _calculateNodeHeight(child, _BASE_CONFIG)
      return true;
    })
    Util.traverseTree(data, child => {
      if (!child.children) {
        return
      }
      const firstElementsOfTheCategory = child.children.filter(c => c.isFirstElementOfTheCategory)
      firstElementsOfTheCategory.forEach(ele => {
        ele.categoryHeight = 0
        child.children.filter(c => c[categoryKey] === ele[categoryKey]).forEach(c => {
          ele.categoryHeight += (c.nodeHeight + c.vGap * 2)
        })
        ele.categoryBorderHeight = ele.categoryHeight - ele.categoryTitleHeight - margin * 2
      })
      return true;
    })
    return changeData(data);
  };

  const graphConfig = {
    container: 'NormalTree',
    renderer: 'svg',
    width: 357 / 375 * window.innerWidth,
    height: 400 / 375 * window.innerWidth,
    fitView: true,
    fitCenter: true,
    minZoom: 0.01,
    layout: {
      type: 'mindmap',
      direction: 'H',
      getWidth: (d) => 250,
      getHeight: (d) => d.nodeHeight,
      getHGap: (d) => {
        return 30
      },
      getVGap: (d) => d.vGap,
      getSide: (d) => d.data.side || 'left'
    },
    defaultEdge: {
      type: 'indentedEdge',
      style: {
        lineWidth: 2,
        radius: 16,
      },
    },
  }

  const tree = new G6.TreeGraph(graphConfig);
  const mapData = buildMapData(sourceData, {
    categoryKey
  })
  if (!mapData) {
    return
  }
  const treeData = dataTransform(mapData)
  tree.data(treeData);
  tree.render();
  return tree
}